import ErrorMessage from "../errors/ErrorMessage";

export default function SelectInput(props) {

  let color = 'primary-200'
  if (props.color) {
    color = `${props.color}-primary`
  }

  return (
    <div>
      {props.value !== "" &&
        <select
          name={props.name}
          id={props.id}
          onChange={props.handleInputChange(props.name)}
          className={`bg-gray-50 border border-gray-300 text-gray-600 sm:text-sm rounded-lg 
          focus:ring-${color} focus:border-${color} block w-full p-2.5 mb-4`}
          required=""
          defaultValue="unselected"
          >
          <option value="unselected" disabled hidden>{props.value}</option>
          {props.options.map((optionContent) =>
            <option key = {optionContent} className="text-gray-900" value={optionContent}>{optionContent}</option>
          )}
        </select>
      }
      {props.value === "" &&
        <select
          name={props.name}
          id={props.id}
          onChange={props.handleInputChange(props.name)}
          className={`bg-gray-50 border border-gray-300 text-gray-600 sm:text-sm rounded-lg 
          focus:ring-${color} focus:border-${color} block w-full p-2.5 mb-4`}
          required=""
          defaultValue="unselected"
          >
          <option value="unselected" disabled hidden>{props.placeholder}</option>
          {props.options.map((optionContent) =>
            <option key = {optionContent} className="text-gray-900" value={optionContent}>{optionContent}</option>
          )}
        </select>
      }

      {props.error ? (
        <div className="-mt-2">
          <ErrorMessage message={props.message}></ErrorMessage>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}